import { FaSearch } from "react-icons/fa";

const InputRetencion = ({
  valor,
  onClick,
  placeholder = "Buscar retencion...",
  nombreRetencion,
  editable = true,
  esRequerido = false
}) => {
  const retencionNombre = nombreRetencion || placeholder;


  return (
    <button
      type="button"
      disabled={!editable}
      onClick={() => onClick(valor)}
      className={`w-full flex items-center justify-between p-2 rounded-xl text-gray-700 border-2 bg-white outline-none transition-all ${
        esRequerido && editable
          ? 'border-red-200 hover:border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
          : 'border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
      }`}
    >
      <span className="truncate text-left">{retencionNombre}</span>
      <FaSearch className="text-verde-claro ml-2" />
    </button>
  );
};

export default InputRetencion;